import React, { Component } from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'

function mapStateToProps(state, hocProps) {
    const id = _.get(hocProps, 'id', null)
    const defaultIndex = _.get(hocProps, 'defaultIndex', 0)

    return {
        activeIndex: state.getIn(['tabs', id, 'activeIndex'], defaultIndex),
    }
}

export default function (InnerComponent) {
    @connect(mapStateToProps)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }

    return HocConnect
}
